import React from "react";
import { Flex, Select } from "antd";
import { taskStatus } from "@utils/optionData/utils";

const MultiSelect = (props) => {
  const { options = [], value = [], onChange = () => {} } = props;
  return (
    <Flex gap={12} vertical>
      <Select
        mode="multiple"
        defaultValue={value}
        placeholder="Outlined"
        style={{
          flex: 1,
        }}
        options={options}
        onChange={onChange}
        optionFilterProp={"label"}
        maxTagTextLength={7}
        maxTagCount={3}
      />
    </Flex>
  );
};

export default MultiSelect;
